'use strict';

const React = require('react');
const PropTypes = require('prop-types');

const ContextComponent = require('../../global/components/ContextComponent');
const Tooltip = require('dibs-react-tooltip');
require('dibs-react-tooltip/dist/main.css');
const FavoriteButton = require('../FavoriteCta/FavoriteButton');

class FavoriteCta extends ContextComponent {

    constructor(props) {
        super(props);

        this._onClick = this._onClick.bind(this);
        this._onMouseEnter = this._onMouseEnter.bind(this);
        this._onMouseLeave = this._onMouseLeave.bind(this);
        this._closeConfirmationTooltip = this._closeConfirmationTooltip.bind(this);

        this.state = {
            mouseIsOver: false,
            confirmationTooltipIsOpen: false,
            buttonClicked: false
        };
    }

    componentWillReceiveProps(nextProps) {
        const {isFetched, isSaved} = this.props;
        const {buttonClicked} = this.state;
        const canShowConfirmation = nextProps.showConfirmation || buttonClicked;

        if (nextProps.isCanceled) {
            this.setState({buttonClicked: false});
        }

        // Should show success message components button was clicked, favorites were
        // fetched already and favorite was saved
        if (
            canShowConfirmation && isFetched && !isSaved && nextProps.isSaved ||
            buttonClicked && !isFetched && nextProps.isFetched && nextProps.isSaved
        ) {
            this._openConfirmationTooltip();
        } else if (isSaved && !nextProps.isSaved) {
            this._closeConfirmationTooltip();
        }
    }

    _openConfirmationTooltip() {
        this.setState({
            confirmationTooltipIsOpen: true,
            buttonClicked: false
        });

        // Close confirmation tooltip after 5 seconds
        this._timeout = setTimeout(this._closeConfirmationTooltip, this.props.closeTimeout);
    }

    _closeConfirmationTooltip() {
        this.setState({
            confirmationTooltipIsOpen: false,
            buttonClicked: false
        });
        clearTimeout(this._timeout);
    }

    _onClick() {
        this.setState({buttonClicked: true});
    }

    _onMouseEnter() {
        this.setState({mouseIsOver: true});
    }

    _onMouseLeave() {
        this.setState({mouseIsOver: false});
    }

    _getConfirmationTooltip() {
        const {confirmationTooltipIsOpen} = this.state;
        const {copy: {confirmationTooltip}, tooltipClass} = this.props;

        if (confirmationTooltip) {
            return (
                <Tooltip hasTriangle={false}
                    isVisible={confirmationTooltipIsOpen}
                    tooltipDirection="right"
                >
                    <div className={tooltipClass} data-tn="favorite-confirmation-tooltip">
                        {confirmationTooltip}
                    </div>
                </Tooltip>
            );
        }

        return null;
    }

    _getCtaTooltip() {
        const {mouseIsOver} = this.state;
        const {tooltipCanBeShown, isSaved, copy: {ctaTooltip}} = this.props;
        const hoverTooltipIsOpen = tooltipCanBeShown && !isSaved && mouseIsOver;

        if (ctaTooltip) {
            return (
                <Tooltip isVisible={hoverTooltipIsOpen} tooltipDirection="bottom">
                    {ctaTooltip}
                </Tooltip>
            );
        }

        return null;
    }

    render() {
        const {className, favoriteData, tracking, copy: {cta}, children} = this.props;

        return (
            <div className="favorites-callout-wrap" ref={c => {this._button = c;}}>
                <FavoriteButton cta={cta}
                    resetCollection
                    className={className}
                    onClick={this._onClick}
                    onMouseEnter={this._onMouseEnter}
                    onMouseLeave={this._onMouseLeave}
                    favoriteData={favoriteData}
                    tracking={tracking}
                    {...this.props}
                />

                {this._getConfirmationTooltip()}
                {this._getCtaTooltip()}
                {children}
            </div>
        );
    }

}

FavoriteCta.propTypes = {
    isSaved: PropTypes.bool.isRequired,
    isFetched: PropTypes.bool.isRequired,
    isCanceled: PropTypes.bool.isRequired,
    tooltipCanBeShown: PropTypes.bool.isRequired,
    copy: PropTypes.object.isRequired,
    favoriteData: PropTypes.object.isRequired,
    className: PropTypes.string,
    tracking: PropTypes.object,
    closeTimeout: PropTypes.number.isRequired,
    tooltipClass: PropTypes.string
};

FavoriteCta.defaultProps = {
    showConfirmation: false,
    tooltipCanBeShown: true,
    closeTimeout: 5000
};

module.exports = FavoriteCta;



// WEBPACK FOOTER //
// ./assets/js/components/FavoriteCta/FavoriteCta.jsx